import { utils } from "ethers";
export const REGISTRY_ID = "0x7085f413A72dCd53D001eb97971bbf25793262cC";
export const PROVIDER_ID = "0x8845A98EF6580d2a109f8FcfC10cc1d6007059fc";
export const DEPOSIT = utils.parseUnits("360000", "gwei"); // ~1hr
export const GAS = 3000000;
//# sourceMappingURL=utils.js.map